import React from 'react';

const PageNotFound: React.FC = () => {
  return <div>Page not found</div>;
};

export default PageNotFound;
